const translations: Record<string, string> = {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About",
  "nav.services": "Services",
  "nav.news": "News",
  "nav.partner": "Become a Partner",
  "nav.cta": "Register as a Grant Applicant",
  "nav.partnerAccess": "Partner Access",

  // Hero
  "hero.label": "Public Consulting Centre — Republic of Moldova",
  "hero.title1": "EU Next Grants",
  "hero.title2": "Consulting & Project Support",
  "hero.subtitle": "We help Moldovan NGOs and civic organizations find, apply for, and successfully implement European and international grant funding — from first call to final report.",
  "hero.cta1": "Register as a Grant Applicant",
  "hero.cta2": "Our Services",
  "hero.scroll": "Scroll",

  // About Preview
  "aboutPreview.label": "About EU Next Grants",
  "aboutPreview.title": "Moldova's dedicated EU grant consulting partner",
  "aboutPreview.p1": "EU Next Grants is a public consulting centre established to bridge the gap between Moldovan civil society and European funding opportunities. We provide end-to-end support — from grant identification and eligibility assessments to full application writing and project implementation oversight.",
  "aboutPreview.p2": "Our team comprises certified grant managers, EU policy specialists, and project management professionals with over a decade of combined experience in EU-funded programming across Eastern Europe.",
  "aboutPreview.link": "Read our full story",
  "aboutPreview.stat1.number": "",
  "aboutPreview.stat1.label": "NGOs Supported",
  "aboutPreview.stat2.number": "",
  "aboutPreview.stat2.label": "Grants Secured",
  "aboutPreview.stat3.number": "",
  "aboutPreview.stat3.label": "EU Programs",

  // Services Preview
  "servicesPreview.label": "What We Do",
  "servicesPreview.title": "Full-cycle grant support, from idea to implementation",
  "servicesPreview.viewAll": "View all 7 services",
  "servicesPreview.explore": "Explore all services",
  "servicesPreview.s01.title": "Grant Identification & Mapping",
  "servicesPreview.s01.desc": "We scan and map open calls from the EU and other major funders, delivering a tailored funding landscape for your organisation.",
  "servicesPreview.s02.title": "Eligibility Assessment",
  "servicesPreview.s02.desc": "Before committing resources, we rigorously evaluate your organisation's eligibility against funding criteria, reducing the risk of disqualification.",
  "servicesPreview.s03.title": "Proposal Writing & Review",
  "servicesPreview.s03.desc": "Our expert writers develop compelling, compliant grant proposals. We also offer independent review and quality assurance on proposals drafted in-house.",
  "servicesPreview.s04.title": "Budget Design & Financial Planning",
  "servicesPreview.s04.desc": "We structure project budgets that are realistic, fully justified, and aligned with funder cost-eligibility rules.",

  // Who We Work With
  "whoWeWork.label": "Who We Work With",
  "whoWeWork.title": "Supporting Moldova's civil society ecosystem",
  "whoWeWork.p": "We work with a broad spectrum of civil society actors in Moldova — from grassroots community organisations to established NGOs with international partnerships. Whether you are applying for your first grant or scaling up a multi-year EU-funded programme, we provide tailored support at every stage.",
  "whoWeWork.cta": "Start a conversation",
  "whoWeWork.supportLabel": "We support",
  "whoWeWork.p1": "Registered NGOs & associations",
  "whoWeWork.p2": "Local public authorities",
  "whoWeWork.p3": "Community foundations",
  "whoWeWork.p4": "Cultural & heritage institutions",
  "whoWeWork.p5": "Youth & civic organizations",
  "whoWeWork.p6": "Research & educational bodies",

  // News Preview
  "newsPreview.label": "Latest from EU Next Grants",
  "newsPreview.title": "News & Grant Calls",
  "newsPreview.viewAll": "View all updates",
  "newsPreview.deadline": "Deadline:",
  "newsPreview.seeAll": "See all {{count}} updates",

  // Contact
  "contact.label": "Contact Us",
  "contact.title": "Start your grant journey today",
  "contact.p": "Reach out for a free initial consultation. Our specialists will review your organisation's profile and advise on the most suitable funding opportunities available to you.",
  "contact.address": "Str. Maria Cebotari 37, Chișinău, Moldova",
  "contact.emailLabel": "info@eunextgrants.md",
  "contact.phone": "+373 22 000 000",
  "contact.hours": "Mon – Fri: 09:00 – 18:00",
  "contact.form.nameLabel": "Full Name *",
  "contact.form.emailLabel": "Email Address *",
  "contact.form.orgLabel": "Organisation",
  "contact.form.messageLabel": "Message *",
  "contact.form.messageNote": "(max 500 chars)",
  "contact.form.namePlaceholder": "Your full name",
  "contact.form.emailPlaceholder": "your@email.com",
  "contact.form.orgPlaceholder": "Your NGO or institution name",
  "contact.form.messagePlaceholder": "Briefly describe your organisation and what kind of support you need...",
  "contact.form.submit": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.error": "Something went wrong. Please try again.",
  "contact.success.title": "Message received",
  "contact.success.p": "Thank you for reaching out. A member of our team will contact you within one business day.",
  "contact.success.again": "Send another message",

  // About Page
  "about.hero.label": "About Us",
  "about.hero.title": "Who we are and what drives us",
  "about.mission.label": "Our Mission",
  "about.mission.title": "Democratizing access to European funding",
  "about.mission.p1": "EU Next Grants was founded on a simple conviction: every Moldovan NGO with a genuine social mission deserves equal access to EU and international grant funding — regardless of size, language capacity, or prior experience with EU bureaucracy.",
  "about.mission.p2": "We operate as a public consulting centre rather than a commercial agency. Our fee structures are designed to be accessible for early-stage organizations, and we regularly provide pro-bono advisory services to community groups in underserved regions.",
  "about.mission.p3": "Our approach is institutional — rigorous, thorough, and grounded in deep knowledge of EU programming cycles, compliance requirements, and impact evaluation standards.",
  "about.stats.s1": "NGOs Supported",
  "about.stats.s2": "Grants Facilitated",
  "about.stats.s3": "Active Programs",
  "about.history.label": "Our History",
  "about.history.title": "A decade of civic impact",
  "about.milestone.2014": "Founded in Chișinău as a civic consulting initiative",
  "about.milestone.2016": "First major EU4Moldova project portfolio — €1.2M secured",
  "about.milestone.2019": "Became an accredited partner of the European Commission EUD in Moldova",
  "about.milestone.2021": "Expanded services to cover GIZ, USAID, and Council of Europe grants",
  "about.milestone.2023": "Surpassed €8M in total grants facilitated for Moldovan civil society",
  "about.milestone.2025": "Launched the Moldova NGO Grant Navigator — open-access resource portal",
  "about.team.label": "Our Team",
  "about.team.title": "Senior specialists, real experience",
  "about.team.0.name": "Elena Moraru",
  "about.team.0.role": "Founding Director & Senior Grant Advisor",
  "about.team.0.bio": "15 years of experience in EU-funded project management. Former advisor to the Ministry of European Integration of Moldova. Certified EU project manager (IPMA Level B).",
  "about.team.1.name": "Andrei Cojocaru",
  "about.team.1.role": "Head of Proposal Development",
  "about.team.1.bio": "Led over 60 successful grant applications to Horizon Europe, Erasmus+, and the EU4Moldova framework. Specialist in logical framework design and narrative writing.",
  "about.team.2.name": "Natalia Rusu",
  "about.team.2.role": "Financial Compliance Specialist",
  "about.team.2.bio": "Expertise in EU budget rules, cost eligibility, and audit preparation. Trained by the European Court of Auditors and the OLAF anti-fraud framework.",
  "about.values.label": "Our Values",
  "about.values.title": "Principled. Transparent. Effective.",
  "about.values.0.title": "Independence",
  "about.values.0.desc": "We operate free of political or commercial interests, ensuring advice is always in your best interest.",
  "about.values.1.title": "Transparency",
  "about.values.1.desc": "Clear pricing, open communication, and full disclosure of our methodologies and limitations.",
  "about.values.2.title": "Excellence",
  "about.values.2.desc": "We hold ourselves to the same standards as EU programme officers — rigorous, evidence-based, and results-oriented.",
  "about.values.3.title": "Accessibility",
  "about.values.3.desc": "Grant support should not be a privilege of large institutions. We actively work to level the playing field.",

  // Services Page
  "services.hero.label": "Our Services",
  "services.hero.title": "Comprehensive grant support, from first call to final report",
  "services.core.label": "Core Services",
  "services.core.title": "Seven areas of specialist support",
  "services.s01.title": "Grant Identification & Funding Landscape Mapping",
  "services.s01.desc": "We conduct a thorough scan of all relevant open calls from the EU, Council of Europe and other major funders active in Moldova. You receive a tailored funding matrix — matched to your sector, size, and strategic priorities.",
  "services.s02.title": "Eligibility Assessment & Pre-Application Analysis",
  "services.s02.desc": "Before any resources are committed, we perform a detailed eligibility check against all funder criteria — legal status, thematic focus, geographic scope, co-financing requirements, and financial thresholds — reducing the risk of administrative rejection.",
  "services.s03.title": "Proposal Writing & Technical Assistance",
  "services.s03.desc": "Our senior writers develop complete, compelling, and fully compliant grant proposals — including the narrative, logical framework, work plan, risk matrix, and evaluation methodology. We also offer independent peer review and quality assurance for proposals drafted by your own team.",
  "services.s04.title": "Budget Design & Financial Planning",
  "services.s04.desc": "We structure project budgets that are realistic, balanced, and fully justified according to funder cost-eligibility rules. This includes staff cost calculations, indirect cost treatment, in-kind contribution valuation, and partner budget allocation.",
  "services.s05.title": "Partnership Development & Consortium Building",
  "services.s05.desc": "Many EU grants require consortia. We assist in identifying and approaching suitable partners — in Moldova and abroad — and help negotiate partnership agreements, define role delineation, and ensure governance clarity within the consortium.",
  "services.s06.title": "Project Implementation Support",
  "services.s06.desc": "Once funded, we provide hands-on implementation support: monitoring and evaluation frameworks, procurement guidance, financial reporting templates, progress report drafting, and communication with Programme Officers on your behalf.",
  "services.s07.title": "Capacity Building & Grant Literacy Training",
  "services.s07.desc": "We deliver tailored training programmes for NGO staff — covering EU grant architecture, proposal writing skills, financial management under EU rules, and PRAG procurement procedures. Available as group workshops or individual mentoring packages.",
  "services.lots.label": "Thematic Areas",
  "services.lots.title": "Grant thematic lots",
  "services.lots.p": "Our consulting work is organized around five thematic lots aligned with the EU's priority programming areas for the Eastern Partnership and Moldova specifically.",
  "services.lot1.lot": "Lot 1",
  "services.lot1.title": "Democracy, Governance & Rule of Law",
  "services.lot1.desc": "Civic engagement, anti-corruption, judicial reform, electoral integrity, and public administration modernization.",
  "services.lot2.lot": "Lot 2",
  "services.lot2.title": "Human Rights & Social Inclusion",
  "services.lot2.desc": "Gender equality, disability rights, refugee and migration support, Roma inclusion, and access to justice.",
  "services.lot3.lot": "Lot 3",
  "services.lot3.title": "Environment, Climate & Green Transition",
  "services.lot3.desc": "Environmental protection, climate adaptation, sustainable energy, waste management, and biodiversity.",
  "services.lot4.lot": "Lot 4",
  "services.lot4.title": "Youth, Education & Cultural Heritage",
  "services.lot4.desc": "Non-formal education, youth leadership, Erasmus+ partnerships, intercultural dialogue, and heritage preservation.",
  "services.lot5.lot": "Lot 5",
  "services.lot5.title": "Local Development & Economic Resilience",
  "services.lot5.desc": "Rural development, SME and cooperative support, social entrepreneurship, local economic diversification.",
  "services.cta.label": "Ready to Apply?",
  "services.cta.title": "Let's find the right grant for your organisation",
  "services.cta.p": "Book a free 30-minute consultation with one of our grant specialists. No commitment required.",
  "services.cta.btn": "Register as a Grant Applicant",

  // News Page
  "news.hero.label": "Stay Informed",
  "news.hero.title": "News & Grant Announcements",
  "news.hero.p": "Open calls, project results, upcoming events, and EU funding updates relevant to Moldovan civil society.",
  "news.cat.all": "All Updates",
  "news.cat.grant-call": "Open Calls",
  "news.cat.news": "News",
  "news.cat.event": "Events",
  "news.cat.result": "Project Results",
  "news.search": "Search news...",
  "news.deadline": "Deadline:",
  "news.readMore": "Read more",
  "news.latest": "Latest",
  "news.moreUpdates": "More Updates",
  "news.noResults.title": "No results found",
  "news.noResults.p": "Try adjusting your search or category filter.",
  "news.sub.label": "Stay Updated",
  "news.sub.title": "Never miss an open grant call",
  "news.sub.p": "We send a concise monthly digest of the most relevant EU and international grant opportunities for Moldovan NGOs.",
  "news.sub.btn": "Request Grant Digest",

  // Register NGO Page
  "register.hero.label": "Partner Network",
  "register.hero.title": "Register your NGO as a partner",
  "register.hero.p": "Join Moldova's growing network of EU-grant-ready civil society organisations. Registration is free and gives your NGO priority access to our consulting services and funding intelligence.",
  "register.why.label": "Why register?",
  "register.why.title": "What partner NGOs receive",
  "register.privacy": "Registration data is used solely for partnership coordination purposes and is not shared with third parties. All information is treated in accordance with EU GDPR requirements.",
  "register.form.label": "Registration Form",
  "register.benefit.0.title": "Access to our grant database",
  "register.benefit.0.desc": "Get monthly curated digests of open calls matched to your sector and capacity.",
  "register.benefit.1.title": "Priority proposal support",
  "register.benefit.1.desc": "Partner NGOs receive fast-track access to our proposal writing and review services.",
  "register.benefit.2.title": "Consortium matchmaking",
  "register.benefit.2.desc": "We actively match registered partners with EU consortium opportunities in their thematic area.",
  "register.benefit.3.title": "Training & capacity building",
  "register.benefit.3.desc": "Exclusive access to grant literacy workshops, webinars, and individual mentoring sessions.",

  // Registration Form
  "form.section.org": "Organisation Details",
  "form.section.projects": "Implemented Projects",
  "form.section.contact": "Contact Person",
  "form.org.name.label": "Full Legal Name of Organisation *",
  "form.org.name.placeholder": "e.g. Association for Civic Development",
  "form.org.field.label": "Field of Activity *",
  "form.org.field.placeholder": "Select a field...",
  "form.org.address.label": "Legal Address *",
  "form.org.address.placeholder": "Street, City, District",
  "form.org.phone.label": "Phone Number *",
  "form.org.phone.placeholder": "+373 XX XXX XXX",
  "form.org.email.label": "Institutional Email *",
  "form.org.email.placeholder": "contact@yourorg.md",
  "form.projects.note": "List 3 to 5 projects your organisation has implemented. Include project name, funder, and brief outcome (max 300 characters each).",
  "form.projects.label": "Project {{n}}",
  "form.projects.optional": "(optional)",
  "form.projects.placeholder": "Project name / Year of implementation",
  "form.projects.add": "Add another project ({{n}}/5)",
  "form.contact.name.label": "Full Name *",
  "form.contact.name.placeholder": "First name, Last name",
  "form.contact.role.label": "Function / Position *",
  "form.contact.role.placeholder": "e.g. Executive Director, Project Manager",
  "form.submit": "Submit Partnership Application",
  "form.submitting": "Submitting...",
  "form.error": "Something went wrong. Please check your entries and try again.",
  "form.success.title": "Application Submitted",
  "form.success.p": "Thank you for registering. Our team will review your organisation's profile and contact you within 3 business days.",
  "form.success.again": "Submit another application",
  "form.activity.democracy": "Democracy & Civic Governance",
  "form.activity.humanrights": "Human Rights & Rule of Law",
  "form.activity.environment": "Environment & Green Transition",
  "form.activity.youth": "Youth, Education & Non-Formal Learning",
  "form.activity.social": "Social Inclusion & Community Development",
  "form.activity.gender": "Gender Equality & Women Empowerment",
  "form.activity.culture": "Culture, Heritage & Creative Arts",
  "form.activity.media": "Media, Journalism & Freedom of Expression",
  "form.activity.health": "Health & Social Services",
  "form.activity.economic": "Local Economic Development",
  "form.activity.research": "Research & Civic Technology",
  "form.activity.other": "Other",

  // Article Page
  "article.notFound.title": "Article not found",
  "article.notFound.p": "The article you're looking for doesn't exist or has been removed.",
  "article.notFound.back": "Back to News",
  "article.back": "Back to News",
  "article.deadline": "Deadline:",
  "article.cta.title": "Need help with this application?",
  "article.cta.p": "Our grant specialists can assess your eligibility and support your proposal for this call.",
  "article.cta.btn": "Get a free consultation",
  "article.sidebar.info": "Key Information",
  "article.sidebar.deadline": "Deadline",
  "article.sidebar.published": "Published",
  "article.sidebar.source": "Source",
  "article.sidebar.category": "Category",
  "article.related": "Related articles",
  "article.allNews": "All news & updates",
  "article.tags": "Tags",

  // Footer
  "footer.tagline": "Helping Moldovan civil society access European and international grant funding.",
  "footer.rights": "All rights reserved.",
};

export default translations;
